export default __webpack_public_path__ + "static/media/ic-edit.0b2807aa.svg";